import { __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import SiriusModal, { SiriusModalFuncProps as ModalFuncProps, SiriusModalProps as ModalProps, SiriusHtmlModal as ISiriusHtmlModal } from './SiriusModal';
import Button from '@lingxi-common-component/sirius-ui/Button';
import classnames from 'classnames';
import styles from './SiriusModal.module.scss';
const Modal = props => {
    const { children, headerBottomLine, footerTopLine, className, bodyStyle, okButtonProps, cancelButtonProps } = props, rest = __rest(props, ["children", "headerBottomLine", "footerTopLine", "className", "bodyStyle", "okButtonProps", "cancelButtonProps"]);
    const [ref, setRef] = useState(null);
    const [init, setInit] = useState(true);
    const restProps = () => {
        if ((props === null || props === void 0 ? void 0 : props.footer) || (props === null || props === void 0 ? void 0 : props.footer) === null)
            return rest;
        else
            return Object.assign(Object.assign({}, rest), { footer: (React.createElement("div", { className: styles.deFooter },
                    React.createElement(Button, Object.assign({ btnType: "minorLine", onClick: e => {
                            (props === null || props === void 0 ? void 0 : props.onCancel) && props.onCancel(e);
                        } }, cancelButtonProps), "\u53D6\u6D88"),
                    React.createElement(Button, Object.assign({ btnType: "primary", onClick: e => {
                            (props === null || props === void 0 ? void 0 : props.onOk) && props.onOk(e);
                        } }, okButtonProps), "\u786E\u5B9A"))) });
    };
    const maxHeight = `${props.footer === null ? 544 : 476}`;
    const maxWidth = 1000;
    const yPadding = +`${props.footer === null ? 20 : 20 * 2}`;
    const xPadding = 20 * 2;
    useEffect(() => {
        setInit(true);
        setTimeout(() => {
            const antModal = document.querySelector('.sirius-modal-wrap');
            const antModalHeader = document.querySelector('.sirius-modal-wrap>.ant-modal-content>.ant-modal-header');
            const antModalFooter = document.querySelector('.sirius-modal-wrap>.ant-modal-content>.ant-modal-footer');
            if (antModal && antModalHeader) {
                antModal.style.maxHeight = '600px';
                antModal.style.maxWidth = '1000px';
                antModalHeader.style.cssText = `height: ${headerBottomLine ? 56 : 48}px;
                 padding: 20px 20px 4px 20px;
                 border-bottom: ${headerBottomLine ? 1 : 0}px solid #f0f3f5;
                `;
            }
            if (antModalFooter) {
                antModalFooter.style.cssText = `height: 68px;
                 padding: 18px 20px;
                 border-top: ${footerTopLine ? 1 : 0}px solid #f0f3f5;
                `;
            }
        }, 0);
    }, [props.visible]);
    useEffect(() => {
        if (!ref)
            return;
        init && fresh();
        const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
        const observer = new MutationObserver(() => {
            setInit(false);
            fresh();
        });
        observer.observe(ref, { childList: true, attributes: true, characterData: true, subtree: true });
        return () => observer.disconnect();
    }, [ref]);
    const fresh = () => {
        if (!ref)
            return;
        const h = ref.scrollHeight;
        const w = ref.scrollWidth;
        const antModalBody = document.querySelector('.sirius-modal-wrap>.ant-modal-content>.ant-modal-body');
        if (antModalBody) {
            if (h + yPadding < +maxHeight) {
                antModalBody.style.overflow = 'visible';
            }
            else {
                antModalBody.style.overflowY = 'auto';
            }
        }
    };
    return (React.createElement(SiriusModal, Object.assign({ bodyStyle: Object.assign({ maxHeight: `${maxHeight}px`, padding: '20px 20px' }, bodyStyle), className: classnames('sirius-modal-wrap', 'global-marketing-modal', className, styles.modalTag) }, restProps()),
        React.createElement("div", { ref: node => setRef(node) }, children)));
};
Modal.confirm = SiriusModal.confirm;
Modal.success = SiriusModal.success;
Modal.error = SiriusModal.error;
Modal.info = SiriusModal.info;
Modal.warning = SiriusModal.warning;
export const SiriusHtmlModal = ISiriusHtmlModal;
export default Modal;
